import { useAIFeatureEnableManager } from "@/src/hooks/AIFeatureEnableManager"
import { selectSRPFloatingAIChatEnabled, setSRPFloatingAIChatEnabled } from "@/src/redux/slices/aiFeatureSlice"
import { useAppDispatch, useAppSelector } from "@/src/redux/store"
import { isCleartrip } from "@/src/utils/generalUtils/isCleartrip"
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome'
import { Box, Chip, Stack, Typography } from "@mui/material"
import { useTranslations } from "next-intl"
import { AIModeToggleTheme } from "../../home/AISearch/AIModeToggleHome"

export const ToggleSRPFloatingAIChatDesktop = () => {
    const t = useTranslations('common')
    const dispatch = useAppDispatch()
    const { srpSmartFilterSort } = useAIFeatureEnableManager()
    const srpFloatingAIChatEnabled = useAppSelector(selectSRPFloatingAIChatEnabled)
    if (!srpSmartFilterSort || srpFloatingAIChatEnabled) return null
    const themes: Record<
        AIModeToggleTheme,
        { primary: string; gradient: string; glow: string }
    > = {
        'yellow-blue': {
            primary: '#184E92',
            gradient: 'linear-gradient(135deg, #184E92 0%, #2a6bbd 60%, #D8C969 140%)',
            glow: '0 10px 28px -10px rgba(24,78,146,0.55)'
        },
        'blue-orange': {
            primary: '#3366CC',
            gradient: 'linear-gradient(135deg, #3366CC 0%, #4a7de0 55%, #F36821 140%)',
            glow: '0 10px 28px -10px rgba(51,102,204,0.55)'
        }
    }

    const variant: AIModeToggleTheme = isCleartrip() ? 'blue-orange' : 'yellow-blue'
    const theme = themes[variant]
    return (
        <Stack
            component="button"
            type="button"
            aria-label={t('aiMode')}
            sx={{
                position: 'relative',
                zIndex: 1,
                display: 'inline-flex',
                alignItems: 'center',
                direction: 'row',
                p: 1,
                borderRadius: 1,
                cursor: 'pointer',
                border: 'none',
                outline: 'none',
                color: '#fff',
                minWidth: 140,
                justifyContent: 'center',
                userSelect: 'none',
                background: theme.gradient,
                boxShadow: 3,
                transition: 'transform .14s ease, box-shadow .24s ease, filter .24s ease',

            }}
            direction="row"
            spacing={0.85}
            onClick={() => dispatch(setSRPFloatingAIChatEnabled({ enabled: true, enableOnboardingPopUp: true }))}
        >
            <Box
                sx={{
                    position: 'relative',
                    display: 'inline-flex',
                    '& .sparkle': {
                        animation: 'aiSpin 2.4s linear infinite'
                    },
                    '@keyframes aiSpin': {
                        '0%': { transform: 'rotate(0deg) scale(1)' },
                        '50%': { transform: 'rotate(180deg) scale(1.15)' },
                        '100%': { transform: 'rotate(360deg) scale(1)' }
                    }
                }}
            >
                <AutoAwesomeIcon className="sparkle" sx={{ fontSize: 18 }} />
            </Box>
            <Typography sx={{ fontWeight: 700, fontSize: 14.5, letterSpacing: 0.2 }}>
                {t('aiMode')}
            </Typography>
            <Chip
                label={t('beta')}
                size="small"
                sx={{
                    height: 18,
                    fontSize: 9.5,
                    fontWeight: 800,
                    letterSpacing: 0.7,
                    color: '#fff',
                    bgcolor: 'transparent',
                    border: '1.5px solid rgba(255,255,255,0.85)',
                    transition: 'all .3s ease',
                    '& .MuiChip-label': { px: 0.7 }
                }}
            />
        </Stack>
    )
}
